import { useState } from 'react'

import './style.scss';
import { useAppDispatch } from '../../redux/hooks';
import { setShowNewPost } from '../../redux/reducers/userSlice';
import { userStateData } from '../../data/userStateData';

function AppPost() {

	const dispatch = useAppDispatch()

	const [selectedCommunity, setSelectedCommunity] = useState<string>('')
	const [postTitle, setPostTitle] = useState<string>('')
	const [postMessage, setPostMessage] = useState<string>('')

	const communitySelectHandler = (newValue: string) => {
		setSelectedCommunity(newValue)
	}
	
	return (
		<>
			<div className='section-wrap app-new-post-wrap'>
				<div className='app-new-post-header-wrap'>
					<img
						src={'/imgs/icons/instructor/icon-instructor-header-back-button.svg'}
						className='app-new-post-back-button'
						alt='Back Button'
						onClick={() => {
							dispatch(setShowNewPost(false))
						}}
					/>
					<button
						className='app-new-post-post-button'
					>Post</button>
				</div>
				<div
					className='app-new-post-community-select-wrap'
				>
					<select
						className='app-new-post-community-select'
						value={selectedCommunity ? selectedCommunity : ''}
						onChange={(evt) => {
							communitySelectHandler(evt.target.value)
						}}
					>
						<option value="" disabled>Select a community</option>
						{userStateData.communities.map((valueLabel: string, index: number) => 
							<option 
								value={valueLabel}
								key={`communityOption${index}`}
							>{valueLabel}</option>
						)}
					</select>
					<img
						className='app-new-post-community-select-icon'
						src='/imgs/icons/posts/icon-new-post-logo.svg'
						alt='Community Logo'
					/>
				</div>
				<input 
					className='app-new-post-title-input'
					value={postTitle}
					placeholder='Title'
					onChange={(evt) => {
						setPostTitle(evt.target.value)
					}}
				/>
				<textarea 
					className='app-new-post-message-input'
					value={postMessage}
					placeholder='What do you want to say'
					onChange={(evt) => {
						setPostMessage(evt.target.value)
					}}
				/>
			</div>
		</>
	)
}

export default AppPost
